module.exports = __webpack_public_path__ + "img/tuoxie.12416393.png";